module.exports = __webpack_public_path__ + "static/media/truck.89c5b422.svg";